{
    "IncludeendedonholdLabel": "Les appels terminés en attente sont abandonnés",
    "UnreturnedCalls_SectionHeader": "Appels non retournés",
    "UnreturnedCalls_SectionPara": "Vous pouvez choisir si certains types d'appels sont considérés comme abandonnés dans les rapports \"Appels perdus non retournés\" ainsi que dans les statistiques \"Appels non retournés\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Les appels terminés par une fuite sont abandonnés"
}